import React from 'react';
import { Link } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './StubScreen.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var b = block('stub-screen');
export function StubScreen(_ref) {
  var image = _ref.image,
    title = _ref.title,
    message = _ref.message,
    linkText = _ref.linkText,
    linkHref = _ref.linkHref,
    type = _ref.type,
    className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: b({
      type: type
    }, className),
    children: [image && /*#__PURE__*/_jsx("div", {
      className: b('image'),
      children: image
    }), title && /*#__PURE__*/_jsx("div", {
      className: b('title'),
      children: title
    }), message && /*#__PURE__*/_jsx("div", {
      className: b('message'),
      children: message
    }), linkHref && /*#__PURE__*/_jsx(Link, {
      href: linkHref,
      children: linkText !== null && linkText !== void 0 ? linkText : i18n('to_search_page')
    })]
  });
}
// #sourceMappingURL=StubScreen.js.map